import React from "react";
import { SvgIcon } from "./SvgIcon";

interface Section {
  id: string;
  label: string;
  iconName: string;
}

interface SettingsSidebarProps {
  sections: Section[];
  activeSection: string;
  onSelectSection: (section: string) => void;
}

export function SettingsSidebar(props: SettingsSidebarProps) {
  return (
    <div style={{
      width: "180px",
      background: "var(--canvas)",
      borderRight: "1px solid var(--line)",
      padding: "16px 0",
      overflowY: "auto"
    }}>
      {props.sections.map((section) => (
        <div
          key={section.id}
          onClick={() => props.onSelectSection(section.id)}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            padding: "12px 16px",
            cursor: "pointer",
            background: props.activeSection === section.id ? "var(--surface2)" : "transparent",
            color: props.activeSection === section.id ? "var(--text)" : "var(--muted)",
            borderLeft: props.activeSection === section.id ? "3px solid var(--accent)" : "3px solid transparent",
            marginLeft: 0,
            paddingLeft: "13px",
            transition: "all 0.2s",
            userSelect: "none"
          }}
          role="button"
          tabIndex={0}
        >
          <SvgIcon
            name={section.iconName}
            title={section.label}
            className="settingsSidebarIcon"
          />
          <span style={{ fontSize: "13px", fontWeight: props.activeSection === section.id ? 600 : 400 }}>
            {section.label}
          </span>
        </div>
      ))}
    </div>
  );
}
